export default {
  signIn: 'Iniciar sesión',
  email: 'Correo electrónico',
  password: 'Contraseña',
  emailPlaceholder: 'nombre@mail.com',
  passwordPlaceholder: 'Ingresa tu contraseña',
  login: 'Ingresar',
  loginWithGoogle: 'Ingresar con Google',
  loginWithMicrosoft: 'Ingresar con Microsoft',
  areYouNew: '¿No tienes una cuenta?',
  register: 'Regístrate',
  errors: {
    missingEmail: 'Escribe tu dirección de correo electrónico.',
    missingPassword: 'Es necesario que escribas tu contraseña.',
    incorrectEmail: 'Correo inválido. Prueba formato nombre@mail.com',
    userNotFound: 'Correo electrónico o contraseña incorrectos.\nPrueba de nuevo'
  },
  forgotPassword: {
    title: '¿Olvidaste o quieres cambiar tu contraseña?',
    text: 'Ingresa tu correo electrónico. Luego, te enviaremos un correo electrónico para crear una nueva contraseña.',
    errors: {
      404: 'El usuario ingresado no existe o no está registrado',
      400: 'El usuario ingresado no está vinculado a ninguna escuela'
    }
  },
  goBackToLogin: 'Volver al inicio de sesión',
  send: 'Enviar',
  mailSendedModal: {
    title: 'Comprueba tu casilla de correo',
    subtitle: 'Sigue las instrucciones para crear una nueva contraseña.',
    buttonText: 'Listo'
  },
  missingSubdomain: 'El subdominio "{subdomain}" no existe',
  corporativeAccess: 'Accesso corporativo',
  back: 'Volver',
  companyId: 'ID de la empresa'
}

export const en = {
  signIn: 'Sign In',
  email: 'Email',
  password: 'Password',
  emailPlaceholder: 'name@mail.com',
  passwordPlaceholder: 'Enter your password',
  login: 'Sign In',
  loginWithGoogle: 'Sign in with Google',
  loginWithMicrosoft: 'Sign in with con Microsoft',
  areYouNew: 'You do not have an account?',
  register: 'Sign up',
  errors: {
    missingEmail: 'Enter your email address.',
    missingPassword: 'Please enter your password',
    incorrectEmail: 'Wrong email format. Try with format name@mail.com',
    userNotFound: 'Wrong email or password. Please try again'
  },
  forgotPassword: {
    title: 'Forgot or want to change your password?',
    text: 'Type your email. We will send you an email to create a new password',
    errors: {
      404: 'The user you entered does not exist or is not registered',
      400: 'The user you entered is not linked to any school'
    }
  },
  goBackToLogin: 'Go back to sign in',
  send: 'Send',
  mailSendedModal: {
    title: 'Check your email',
    subtitle: 'Follow the instructions to create a new password.',
    buttonText: 'Done'
  },
  missingSubdomain: 'El subdominio "{subdomain}" no existe'
}

export const ca = {
  signIn: 'Inicia sessió',
  email: 'Correu electrònic',
  password: 'Paraula de pas',
  emailPlaceholder: 'nom@mail.com',
  passwordPlaceholder: 'Introdueix la paraula de pas',
  login: 'Entra',
  loginWithGoogle: 'Ingressar amb Google',
  loginWithMicrosoft: 'Ingressar amb Microsoft',
  areYouNew: 'No tens un compte?',
  register: 'Registra\'t',
  errors: {
    missingEmail: 'Escriu la teva adreça de correu electrònic.',
    missingPassword: 'Has d\'escriure la teva paraula de pas.',
    incorrectEmail: 'Adreça de correu invàlida. Prova de format nom@mail.com',
    userNotFound: 'Adreça de correu electrònic o paraula de pas incorrectes.\nProva una altra vegada'
  },
  forgotPassword: {
    title: 'Has oblidat o vols canviar la teva contrasenya?',
    text: 'Introdueix la teva adreça de correu electrònic. Un cop fet, rebràs un correu electrònic per poder crear una paraula de pas nova.',
    errors: {
      404: 'L\'usuari introduït no existeix o no està registrat',
      400: 'L\'usuari introduït no està vinculat a cap escola'
    }
  },
  goBackToLogin: 'Torna a l\'inici de sessió',
  send: 'Envia',
  mailSendedModal: {
    title: 'Comprova la teva bústia',
    subtitle: 'Segueix les instruccions per crear una paraula de pas nova.',
    buttonText: 'Fet'
  },
  missingSubdomain: 'El subdominio "{subdomain}" no existe'
}
